const formatTime = (time: string) => {
  const nowToday = new Date(time);
  const minutes =
    (nowToday.getMinutes() < 10 ? '0' : '') + nowToday.getMinutes();

  return `${nowToday.getHours()}:${minutes}`;
};

export default formatTime;
